export default "__VITE_ASSET__4049c31f__"